import { render, staticRenderFns } from "./addDetail.vue?vue&type=template&id=64baef03&scoped=true"
import script from "./addDetail.vue?vue&type=script&lang=js"
export * from "./addDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64baef03",
  null
  
)

export default component.exports